export const BOLLARD_UNLIT = 'Bollard';
export const BOLLARD_LIT = 'BollardLit';
export const SIGN_UNLIT = 'Sign';
export const SIGN_LIT = 'SignLit';
export const STREET_NAME_SIGN_UNLIT = 'StreetNameplate';
